import { ValidatorFunction } from './_interfaces/ValidatorFunction';
import { ValidationStateMessage } from './_interfaces/ValidationStateMessage';

/**
 * Default validator function
 * Returns a Promise that resolves an object that conforms to interface ValidationStateMessage
 *
 * @see ValidationStateMessage
 * @see https://github.com/hp-dcss/hp6-web-component-library/tree/develop/src/components/_form/_form-kit/inline-validator/_interfaces/ValidationStateMessage.ts
 * @param formControl FormControl
 * @returns ValidationStateMessage
 */

const defaultValidator: ValidatorFunction = ({
  formControl,
}): Promise<ValidationStateMessage> => {
  let isValid = false;
  let message: string | undefined;

  if (formControl.type === 'fieldset') {
    // fieldset.validate() does not match CSS :valid
    // only CSS gets it right for fieldset
    if (formControl.parentElement.querySelector('fieldset:valid')) {
      isValid = true;
    }
  } else {
    // formControl.validity is an object of ValidityState
    // https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
    // validationMessage is the browser's default message
    const { validity, validationMessage } = formControl;

    // valid is boolean
    const { valid } = validity;

    if (valid) {
      isValid = true;
    }
    message = validationMessage;
  }

  // the ValidatorFunction needs to return a Promise that resolves an object that
  // implements interface ValidationStateMessage
  // https://github.com/hp-dcss/hp6-web-component-library/tree/develop/src/components/_form/_form-kit/inline-validator/_interfaces/ValidationStateMessage.ts

  const validation = {
    isValid,
    message,
  };

  return Promise.resolve(validation);
};

export default defaultValidator;
